export default __webpack_public_path__ + "static/media/discover.9f8a31de.svg";